import { saveUserSettings, userSettings } from "@/globals/userSettings";
import runAccessibility from "./runAccessibility";
import selectButtons from "@/tools/selectButtons";
import renderTools from "./renderTools";

export default function reset($menu: HTMLElement) {

    $menu?.querySelectorAll(".cya11y-selected")?.forEach(el => el?.classList?.remove("cya11y-selected"))
    $menu.querySelector(".cya11y-amount").textContent = `100%`;
    userSettings.states = {};
    runAccessibility();
    saveUserSettings();
}